'use client';

import { useContext } from 'react';
import { ColorModeContext, type ColorModeContextValue } from './ColorModeProvider';

export function useMode(): ColorModeContextValue {
  const ctx = useContext(ColorModeContext);
  if (!ctx) throw new Error('useMode must be called inside <ThemeProvider>');
  return ctx;
}

export type { ColorMode, ResolvedColorMode, ColorModeContextValue } from './ColorModeProvider';
